import React from "react";
import LoadingOverlay from "react-loading-overlay-nextgen";
import backdrop from "../Backdrop/Backdrop";

LoadingOverlay.propTypes = undefined;

const Spinner = () => {
  return (
    <LoadingOverlay
      active={true}
      // spinner={<BounceLoader />}
      spinner={true}
      text="Loading..."
      styles={{
        overlay: (base) => ({
          ...base,
          top: '40vh'
        })
      }}
    >
    </LoadingOverlay>
  );
};

export default backdrop(Spinner);